
import { gql } from "@apollo/client";
import { apolloClient } from "../../services/apolloclient";

export const GET_FOODMENU = gql`
  query MyQuery {
    menupage {
    
      cafegpSignatureTitle
      foodSection {
        contentItems {
          ... on FoodComponent {
            foodItemName
            foodItemImage {
              urls
            }
            imageAllignmentWithPlane
            enabled
          }
        }
      }
    }
  }
`;

export async function fetchFoodMenu() {
  const result = await apolloClient.query({
    query: GET_FOODMENU,
    fetchPolicy: "network-only",
  });

  return result.data;
}
